import { DateTime } from 'luxon';
import { YEAR_FORMAT_LUXON } from '@startuptools/common/common';
import { type GqlMeeting, GqlFiscalYear, GqlMeetingKind } from '../graphql/base-types.graphql';

const FISCAL_FORMAT_LUXON = 'MMM';

export function fiscalPeriod(fiscalYear: GqlFiscalYear, date: DateTime): { start: DateTime; end: DateTime } {
  const [fiscalStart, fiscalEnd] = fiscalYear.split('To');
  let start = DateTime.fromFormat(
    date.toFormat(YEAR_FORMAT_LUXON) + fiscalStart,
    `${YEAR_FORMAT_LUXON}${FISCAL_FORMAT_LUXON}`,
    { locale: 'en-US' },
  ).startOf('month');

  let end = DateTime.fromFormat(
    date.toFormat(YEAR_FORMAT_LUXON) + fiscalEnd,
    `${YEAR_FORMAT_LUXON}${FISCAL_FORMAT_LUXON}`,
    { locale: 'en-US' },
  )
    .endOf('month')
    .startOf('day');

  if (start > date) {
    start = start.minus({ year: 1 });
  } else if (end < date) {
    end = end.plus({ year: 1 });
  }
  return { start, end };
}

export function agmPeriod(fiscalYear: GqlFiscalYear, date: DateTime): { start: DateTime; end: DateTime } {
  const { start, end } = fiscalPeriod(fiscalYear, date);

  return { start, end: end.minus({ months: 6 }) };
}

export function isBetween(range: { start: DateTime; end: DateTime }, date: DateTime): boolean {
  return date >= range.start && date <= range.end;
}

export function getAgmSameYear(
  meetings: Pick<GqlMeeting, 'id' | 'kind' | 'startTime'>[],
  fiscalYear: GqlFiscalYear,
  date: DateTime,
): Pick<GqlMeeting, 'id'> | undefined {
  const agmP = agmPeriod(fiscalYear, date);
  return meetings.find(
    m => m.kind === GqlMeetingKind.ShareholdersMeeting && isBetween(agmP, DateTime.fromISO(m.startTime)),
  );
}
